import ImageCollectionPage from "../components/ImageCollectionPage";

export default function Stickers() {
  return <ImageCollectionPage title="Stickers" path="/gallery/stickers" collection="gallery_stickers" />;
}
